import { useState } from 'react';

const HomePage = () => {
  const [selectedService, setSelectedService] = useState('');
  const [showContactForm, setShowContactForm] = useState(false);
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [showDeliveryForm, setShowDeliveryForm] = useState(false);
  const [serviceType, setServiceType] = useState('');

  const services = [
    {
      id: 'pan-card',
      title: 'PAN कार्ड',
      description: 'PAN कार्ड प्रिंटिंग और नया PAN कार्ड बनवाना',
      icon: 'ri-file-text-line',
      online: true,
      offline: true,
      delivery: true
    },
    {
      id: 'aadhar-card',
      title: 'आधार कार्ड',
      description: 'आधार कार्ड प्रिंटिंग और अपडेट सेवाएं',
      icon: 'ri-id-card-line',
      online: true,
      offline: true,
      delivery: true
    },
    {
      id: 'voter-id',
      title: 'वोटर ID',
      description: 'वोटर ID कार्ड बनवाना और प्रिंटिंग',
      icon: 'ri-government-line',
      online: true,
      offline: true,
      delivery: true
    },
    {
      id: 'passport',
      title: 'पासपोर्ट',
      description: 'पासपोर्ट अप्लाई करना और रिन्यूअल',
      icon: 'ri-passport-line',
      online: true,
      offline: true,
      delivery: true
    },
    {
      id: 'ration-card',
      title: 'राशन कार्ड',
      description: 'राशन कार्ड बनवाना और प्रिंटिंग',
      icon: 'ri-restaurant-line',
      online: true,
      offline: true,
      delivery: true
    },
    {
      id: 'driving-license',
      title: 'ड्राइविंग लाइसेंस',
      description: 'ड्राइविंग लाइसेंस बनवाना और रिन्यूअल',
      icon: 'ri-car-line',
      online: true,
      offline: true,
      delivery: true
    },
    {
      id: 'birth-certificate',
      title: 'जन्म प्रमाण पत्र',
      description: 'जन्म प्रमाण पत्र बनवाना और प्रिंटिंग',
      icon: 'ri-baby-line',
      online: true,
      offline: true,
      delivery: true
    },
    {
      id: 'income-certificate',
      title: 'आय प्रमाण पत्र',
      description: 'आय प्रमाण पत्र बनवाना और सत्यापन',
      icon: 'ri-money-rupee-circle-line',
      online: true,
      offline: true,
      delivery: true
    },
    {
      id: 'caste-certificate',
      title: 'जाति प्रमाण पत्र',
      description: 'जाति प्रमाण पत्र बनवाना और सत्यापन',
      icon: 'ri-user-star-line',
      online: true,
      offline: true,
      delivery: true
    },
    {
      id: 'domicile-certificate',
      title: 'निवास प्रमाण पत्र',
      description: 'निवास प्रमाण पत्र बनवाना और सत्यापन',
      icon: 'ri-home-line',
      online: true,
      offline: true,
      delivery: true
    },
    {
      id: 'bank-services',
      title: 'बैंक सेवाएं',
      description: 'खाता खोलना, चेकबुक, ATM कार्ड सेवाएं',
      icon: 'ri-bank-line',
      online: true,
      offline: true,
      delivery: true
    },
    {
      id: 'other-docs',
      title: 'अन्य डॉक्यूमेंट',
      description: 'अन्य सरकारी दस्तावेज़ की सेवाएं',
      icon: 'ri-folder-line',
      online: true,
      offline: true,
      delivery: true
    }
  ];

  const handleServiceClick = (service: any, type: 'online' | 'offline' | 'delivery') => {
    setSelectedService(service.id);
    setServiceType(type);
    if (type === 'delivery') {
      setShowDeliveryForm(true);
    } else {
      setShowBookingForm(true);
    }
  };

  const handleContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const data = new URLSearchParams();
    
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });

    try {
      const response = await fetch('https://readdy.ai/api/form/d48iokjhnd8fvojd3020', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data
      });

      if (response.ok) {
        alert('आपका संदेश भेज दिया गया है! हम जल्दी ही आपसे संपर्क करेंगे।');
        setShowContactForm(false);
        (e.target as HTMLFormElement).reset();
      }
    } catch (error) {
      alert('कुछ गलत हुआ है। कृपया दोबारा कोशिश करें।');
    }
  };

  const handleBookingSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const data = new URLSearchParams();
    
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });

    try {
      const response = await fetch('https://readdy.ai/api/form/d48iokjhnd8fvojd302g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data
      });

      if (response.ok) {
        alert('आपकी सेवा बुक हो गई है! हम जल्दी ही आपसे संपर्क करेंगे।');
        setShowBookingForm(false);
        (e.target as HTMLFormElement).reset();
      }
    } catch (error) {
      alert('कुछ गलत हुआ है। कृपया दोबारा कोशिश करें।');
    }
  };

  const handleDeliverySubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const data = new URLSearchParams();
    
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });

    try {
      const response = await fetch('https://readdy.ai/api/form/d48iokjhnd8fvojd302h', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data
      });

      if (response.ok) {
        alert('आपका डिलीवरी ऑर्डर बुक हो गया है! हम जल्दी ही आपसे संपर्क करेंगे।');
        setShowDeliveryForm(false);
        (e.target as HTMLFormElement).reset();
      }
    } catch (error) {
      alert('कुछ गलत हुआ है। कृपया दोबारा कोशिश करें।');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      {/* Header */}
      <header className="bg-white shadow-lg">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full flex items-center justify-center">
                <i className="ri-service-line text-white text-xl"></i>
              </div>
              <h1 className="text-2xl font-bold text-gray-800" style={{fontFamily: '"Pacifico", serif'}}>
                ऑल इन वन ऑनलाइन सर्विस
              </h1>
            </div>
            <div className="flex items-center space-x-4">
              <a href="tel:8409027163" className="flex items-center space-x-2 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-phone-line"></i>
                <span>8409027163</span>
              </a>
              <button 
                onClick={() => setShowContactForm(true)}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                संपर्क करें
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-blue-600 to-indigo-700 text-white">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center max-w-4xl mx-auto">
            <h2 className="text-5xl font-bold mb-6">
              सभी सरकारी दस्तावेज़ की सेवाएं एक ही जगह
            </h2>
            <p className="text-xl mb-8 text-blue-100">
              PAN कार्ड, आधार कार्ड, वोटर ID, पासपोर्ट, राशन कार्ड, ड्राइविंग लाइसेंस और अन्य सभी सरकारी दस्तावेज़ की ऑनलाइन, ऑफलाइन और होम डिलीवरी सेवाएं
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
                <span className="text-green-300">✓</span> तुरंत सेवा
              </div>
              <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
                <span className="text-green-300">✓</span> सुरक्षित प्रक्रिया
              </div>
              <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
                <span className="text-green-300">✓</span> कम कीमत
              </div>
              <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
                <span className="text-green-300">✓</span> होम डिलीवरी
              </div>
              <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
                <span className="text-green-300">✓</span> 24/7 सपोर्ट
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Delivery Features Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h3 className="text-4xl font-bold text-gray-800 mb-4">होम डिलीवरी सेवा</h3>
            <p className="text-xl text-gray-600">अब घर बैठे मंगवाएं अपने सभी दस्तावेज़</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center p-6 bg-gradient-to-br from-green-50 to-emerald-100 rounded-xl">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-truck-line text-white text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-2">तेज़ डिलीवरी</h4>
              <p className="text-gray-600">24-48 घंटे में आपके घर तक डिलीवरी</p>
            </div>

            <div className="text-center p-6 bg-gradient-to-br from-blue-50 to-cyan-100 rounded-xl">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-white text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-2">सुरक्षित पैकेजिंग</h4>
              <p className="text-gray-600">आपके दस्तावेज़ सुरक्षित रूप से पैक करके भेजे जाते हैं</p>
            </div>

            <div className="text-center p-6 bg-gradient-to-br from-purple-50 to-violet-100 rounded-xl">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-line text-white text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-2">ट्रैकिंग सुविधा</h4>
              <p className="text-gray-600">अपने ऑर्डर की स्थिति जानें</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h3 className="text-4xl font-bold text-gray-800 mb-4">हमारी सेवाएं</h3>
            <p className="text-xl text-gray-600">सभी सरकारी दस्तावेज़ की सेवाएं ऑनलाइन, ऑफलाइन और होम डिलीवरी उपलब्ध</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {services.map((service) => (
              <div key={service.id} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
                <div className="text-center mb-6">
                  <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${service.icon} text-white text-2xl`}></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-800 mb-2">{service.title}</h4>
                  <p className="text-gray-600 text-sm">{service.description}</p>
                </div>

                <div className="space-y-2">
                  {service.online && (
                    <button
                      onClick={() => handleServiceClick(service, 'online')}
                      className="w-full bg-green-600 text-white py-2 px-4 rounded-lg hover:bg-green-700 transition-colors flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer text-sm"
                    >
                      <i className="ri-wifi-line"></i>
                      <span>ऑनलाइन सेवा</span>
                    </button>
                  )}
                  {service.offline && (
                    <button
                      onClick={() => handleServiceClick(service, 'offline')}
                      className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer text-sm"
                    >
                      <i className="ri-store-line"></i>
                      <span>ऑफलाइन सेवा</span>
                    </button>
                  )}
                  {service.delivery && (
                    <button
                      onClick={() => handleServiceClick(service, 'delivery')}
                      className="w-full bg-orange-600 text-white py-2 px-4 rounded-lg hover:bg-orange-700 transition-colors flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer text-sm"
                    >
                      <i className="ri-truck-line"></i>
                      <span>होम डिलीवरी</span>
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Payment Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h3 className="text-4xl font-bold text-gray-800 mb-4">पेमेंट करें</h3>
            <p className="text-xl text-gray-600">PhonePe के माध्यम से आसान और सुरक्षित पेमेंट</p>
          </div>

          <div className="max-w-md mx-auto bg-gray-50 rounded-xl p-8 text-center">
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/36f184859bfc19933ddb65f097d319cb/c89ff1304071df390cd30b3ae6b63925.png"
                alt="PhonePe QR Code for Payment"
                className="w-64 h-64 mx-auto rounded-lg shadow-lg object-contain"
              />
            </div>
            
            <div className="space-y-4">
              <div className="bg-white p-4 rounded-lg">
                <div className="flex items-center justify-center mb-2">
                  <div className="w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center mr-2">
                    <span className="text-white font-bold text-sm">₹</span>
                  </div>
                  <span className="text-lg font-bold text-gray-800">PhonePe</span>
                </div>
                <p className="text-sm text-gray-600">ACCEPTED HERE</p>
              </div>
              
              <div className="bg-white p-4 rounded-lg">
                <p className="text-sm text-gray-600 mb-2">नाम:</p>
                <p className="text-lg font-bold text-gray-800">ABHISHEK KUMAR</p>
              </div>
              
              <p className="text-sm text-gray-600">
                PhonePe ऐप से QR कोड स्कैन करके पेमेंट करें
              </p>
              
              <div className="bg-green-50 p-3 rounded-lg">
                <p className="text-sm text-green-700 font-medium">
                  ✓ सुरक्षित और तुरंत पेमेंट
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 bg-gradient-to-r from-gray-800 to-gray-900 text-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h3 className="text-4xl font-bold mb-4">संपर्क जानकारी</h3>
            <p className="text-xl text-gray-300">हमसे जुड़ें और अपनी समस्या का समाधान पाएं</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-white text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">फोन नंबर</h4>
              <a href="tel:8409027163" className="text-green-400 hover:text-green-300 cursor-pointer">
                8409027163
              </a>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-white text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">ईमेल</h4>
              <button 
                onClick={() => setShowContactForm(true)}
                className="text-blue-400 hover:text-blue-300 cursor-pointer"
              >
                संदेश भेजें
              </button>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-white text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">समय</h4>
              <p className="text-gray-300">सोमवार - शनिवार<br />9:00 AM - 7:00 PM</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full flex items-center justify-center">
                <i className="ri-service-line text-white"></i>
              </div>
              <h5 className="text-xl font-bold" style={{fontFamily: '"Pacifico", serif'}}>
                ऑल इन वन ऑनलाइन सर्विस
              </h5>
            </div>
            <p className="text-gray-400 mb-4">
              सभी सरकारी दस्तावेज़ की सेवाएं एक ही जगह
            </p>
            <div className="flex justify-center space-x-6">
              <a href="tel:8409027163" className="text-gray-400 hover:text-white cursor-pointer">
                <i className="ri-phone-line text-xl"></i>
              </a>
              <button onClick={() => setShowContactForm(true)} className="text-gray-400 hover:text-white cursor-pointer">
                <i className="ri-mail-line text-xl"></i>
              </button>
            </div>
            <div className="mt-6 pt-6 border-t border-gray-800">
              <p className="text-gray-500 text-sm">
                © 2024 ऑल इन वन ऑनलाइन सर्विस. सभी अधिकार सुरक्षित. 
                <a href="https://readdy.ai/?origin=logo" className="text-blue-400 hover:text-blue-300 ml-2 cursor-pointer">
                  Powered by Readdy
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Contact Form Modal */}
      {showContactForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-md w-full p-6">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold text-gray-800">संपर्क करें</h3>
              <button 
                onClick={() => setShowContactForm(false)}
                className="text-gray-500 hover:text-gray-700 cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <form onSubmit={handleContactSubmit} data-readdy-form id="contact-form">
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    नाम *
                  </label>
                  <input
                    type="text"
                    name="name"
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="आपका नाम"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    फोन नंबर *
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="आपका फोन नंबर"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    संदेश *
                  </label>
                  <textarea
                    name="message"
                    required
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                    placeholder="आपका संदेश (अधिकतम 500 अक्षर)"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  संदेश भेजें
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Service Booking Modal */}
      {showBookingForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-md w-full p-6">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold text-gray-800">सेवा बुक करें</h3>
              <button 
                onClick={() => setShowBookingForm(false)}
                className="text-gray-500 hover:text-gray-700 cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <form onSubmit={handleBookingSubmit} data-readdy-form id="service-booking">
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    नाम *
                  </label>
                  <input
                    type="text"
                    name="name"
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="आपका नाम"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    फोन नंबर *
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="आपका फोन नंबर"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    सेवा का प्रकार *
                  </label>
                  <input
                    type="text"
                    name="service_type"
                    value={`${services.find(s => s.id === selectedService)?.title} - ${serviceType === 'online' ? 'ऑनलाइन' : 'ऑफलाइन'}`}
                    readOnly
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 text-sm"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    विवरण
                  </label>
                  <textarea
                    name="details"
                    maxLength={500}
                    rows={3}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                    placeholder="अतिरिक्त जानकारी (अधिकतम 500 अक्षर)"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-green-600 text-white py-3 px-4 rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  सेवा बुक करें
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delivery Booking Modal */}
      {showDeliveryForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-md w-full p-6 max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold text-gray-800">होम डिलीवरी बुक करें</h3>
              <button 
                onClick={() => setShowDeliveryForm(false)}
                className="text-gray-500 hover:text-gray-700 cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <form onSubmit={handleDeliverySubmit} data-readdy-form id="delivery-booking">
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    नाम *
                  </label>
                  <input
                    type="text"
                    name="name"
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                    placeholder="आपका नाम"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    फोन नंबर *
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                    placeholder="आपका फोन नंबर"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    सेवा का प्रकार *
                  </label>
                  <input
                    type="text"
                    name="service_type"
                    value={`${services.find(s => s.id === selectedService)?.title} - होम डिलीवरी`}
                    readOnly
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 text-sm"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    पूरा पता *
                  </label>
                  <textarea
                    name="address"
                    required
                    maxLength={500}
                    rows={3}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm resize-none"
                    placeholder="घर का पूरा पता, शहर, पिन कोड (अधिकतम 500 अक्षर)"
                  ></textarea>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    पिन कोड *
                  </label>
                  <input
                    type="text"
                    name="pincode"
                    required
                    pattern="[0-9]{6}"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                    placeholder="6 अंकों का पिन कोड"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    डिलीवरी का समय
                  </label>
                  <div className="grid grid-cols-2 gap-2">
                    <label className="flex items-center space-x-2 p-2 border rounded-lg cursor-pointer hover:bg-gray-50">
                      <input type="radio" name="delivery_time" value="सुबह 9-12" className="text-orange-600" />
                      <span className="text-sm">सुबह 9-12</span>
                    </label>
                    <label className="flex items-center space-x-2 p-2 border rounded-lg cursor-pointer hover:bg-gray-50">
                      <input type="radio" name="delivery_time" value="दोपहर 12-4" className="text-orange-600" />
                      <span className="text-sm">दोपहर 12-4</span>
                    </label>
                    <label className="flex items-center space-x-2 p-2 border rounded-lg cursor-pointer hover:bg-gray-50">
                      <input type="radio" name="delivery_time" value="शाम 4-7" className="text-orange-600" />
                      <span className="text-sm">शाम 4-7</span>
                    </label>
                    <label className="flex items-center space-x-2 p-2 border rounded-lg cursor-pointer hover:bg-gray-50">
                      <input type="radio" name="delivery_time" value="कोई भी समय" className="text-orange-600" />
                      <span className="text-sm">कोई भी समय</span>
                    </label>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    विशेष निर्देश
                  </label>
                  <textarea
                    name="special_instructions"
                    maxLength={500}
                    rows={2}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm resize-none"
                    placeholder="डिलीवरी के लिए कोई विशेष निर्देश (अधिकतम 500 अक्षर)"
                  ></textarea>
                </div>

                <div className="bg-orange-50 p-4 rounded-lg">
                  <div className="flex items-start space-x-2">
                    <i className="ri-information-line text-orange-600 mt-1"></i>
                    <div className="text-sm text-orange-800">
                      <p className="font-medium mb-1">डिलीवरी की जानकारी:</p>
                      <ul className="space-y-1 text-xs">
                        <li>• डिलीवरी चार्ज अलग से लगेगा</li>
                        <li>• 24-48 घंटे में डिलीवरी</li>
                        <li>• पेमेंट डिलीवरी के समय</li>
                        <li>• ट्रैकिंग जानकारी SMS से मिलेगी</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <button
                  type="submit"
                  className="w-full bg-orange-600 text-white py-3 px-4 rounded-lg hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  होम डिलीवरी बुक करें
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomePage;